import React from 'react';
import Header from '../components/Header'
import BoxWrapper from '../components/BoxWrapper/BoxWrapper';
import List from './price_channel/List'

const PriceChannel = () => {
	return (
		<>
			<Header />

			<BoxWrapper>
				<List />
			</BoxWrapper>
		</>
	)
}

export default PriceChannel